var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({staticClass:"ma-1",attrs:{"close":_vm.deletable,"small":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.text))]),_vm._v("\n   \n  "),_c('span',{staticClass:"grey--text caption text--darken-2"},[_vm._v("\n    "+_vm._s(_vm.caption)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }